import React, { useRef, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useSelector, useDispatch } from "react-redux";
import MaterialModal from "../MaterialModal";
import { hideModal } from "../../../actions/actionCreators";
import h from "../../../helpers";
import { validSnowflakeTableSpaces, validStartChar } from "../../../helpers/snowflakeValidation";
import withModal from "../withModal";
import MultipleAudienceRadiusMap from "./MultipleAudienceRadiusMap";
import { Checkbox, FormControl, FormControlLabel, FormHelperText, IconButton, TextField } from "@material-ui/core";
import { getAvailableFolders } from "../../../actions/fileImportActions";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { sortSelectOptions } from "../../../helpers/selectHelper";
import Paper from "@material-ui/core/Paper";
import Divider from "@material-ui/core/Divider";
import Icon from "@material-ui/core/Icon";
// OmniActivation\client\actions\fileImportQueueActions.ts

const AudienceMultipleRadiusModal = ({ isOpen }) => {
    const dispatch = useDispatch();

    const [radius, setRadius] = useState(10);
    const [latlng, setLatLng] = useState(null);
    const [circleLatLng, setCircleLatLng] = useState([39.470125122, -5436.562500000001]); //Place it somewhere VERY far off, circle acts weird when it doesn't exist initially
    const [errors, setErrors] = useState({});
    const [zipFileName, setZipFileName] = useState("");
    const [foundLocation, setFoundLocation] = useState("");
    const [retentionDays, setRetentionDays] = useState(0);
    const [newFolderName, setNewFolderName] = useState("");
    const [selectedFolder, setSelectedFolder] = useState(null);
    const [dontCrossState, setDontCrossState] = useState(false);
    const [markers, setMarkers] = useState([{ id: 0, position: { lat: 0, lng: 0 } }]);
    const [isDisabled, setIsDisabled] = useState(true);

    const successContainer = useRef(null);
    const parsingContainer = useRef(null);
    const infoContainer = useRef(null);
    const successMessage = useRef(null);
    const parsingMessage = useRef(null);

    const folders = useSelector(state => state.fileImport.folders);
    const enabledFeatures = useSelector(state => state.session.enabledFeatures || []);
    const hasRetentionFeature = enabledFeatures.includes("table-retention-period");

    const retentionDaysDefault = 90;
    foundLocation;
    const [fileName, setFileName] = useState("");

    const fileUploadSettings = useSelector(state => state.fileUploadSettings.fileUploadSetting);
    const [fileSelected, setFileSelected] = useState(null);

    const saveFileSelected = e => {
        setFileSelected(e.target.files[0]);
        setIsDisabled(false);
    };

    const importFile = () => {
        if (!validate()) {
            return;
        }
        let iconContent = fileSelected;
        let iconData = new FormData();
        iconData.append("Icon", iconContent);
        iconData.append("IsLogo", String(false));
        iconData.append("zipFileName", zipFileName.trim());
        iconData.append("locationFileName", fileUploadSettings.RequestedName);
        iconData.append("radius", radius);
        iconData.append("retentionDays", retentionDays);
        iconData.append("parentFolder", newFolderName ? selectedFolder.value : selectedFolder.label);
        iconData.append("childFolder", newFolderName);
        iconData.append("dontCrossState", dontCrossState);
        $(infoContainer.current).show();
        fetch("/api/RadiusFile/UploadRadiusFileAsync", {
            credentials: "same-origin",
            method: "POST",
            body: iconData,
        })
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                $(infoContainer.current).hide();
                if (!data.success) {
                    handleSubmitError();
                    throw new Error("There was a problem parsing the file.");
                }
                data.locationArray.forEach(async el => {
                    setMarkers(oldArray => [
                        ...oldArray,
                        { id: oldArray.length, position: { lat: el.Latitude, lng: el.Longitude } },
                    ]);
                });
                $(infoContainer.current).hide();
                $(successContainer.current).show();
                $(successMessage.current).text(
                    "Your radius (zip) file has been successfully created. " + data.numSaved + " zips were saved."
                );
                handleSubmitSuccess();
            })
            .catch(error => {
                $(infoContainer.current).hide();
                $(successContainer.current).show();
                $(successMessage.current).text(error);
            });
    };

    useEffect(() => {
        if (hasRetentionFeature) {
            setRetentionDays(retentionDaysDefault);
        }
    }, [retentionDaysDefault, hasRetentionFeature]);

    useEffect(() => {
        if (isOpen && (!folders || folders.length <= 0)) {
            dispatch(getAvailableFolders());
        }
    }, [dispatch, folders, isOpen]);

    const resetState = () => {
        setRadius(10);
        setLatLng(null);
        setCircleLatLng([39.470125122, -5436.562500000001]);
        setErrors({});
        setZipFileName("");
        setFoundLocation("");
        setMarkers(() => [{ id: 0, position: { lat: 0, lng: 0 } }]);
        setFileSelected(null);
    };

    const hide = () => {
        resetState();
        dispatch(hideModal("AUDIENCE_MULTIPLE_RADIUS"));
        setIsDisabled(true);
        setMarkers(() => [{ id: 0, position: { lat: 0, lng: 0 } }]);
    };

    const DownloadSampleFile = () => (window.location = "/Main/DownloadSampleRadiusFile");

    const validate = () => {
        const e = {};

        if (!isNumeric(radius)) {
            e.Radius = "Please enter a numeric value for radius.";
        }

        if (!zipFileName) {
            e.zipFileName = "Please enter a name for your radius filter.";
        }

        if (validStartChar(zipFileName)) {
            e.zipFileName = "The Filter Name must begin with an alpha character.";
        }

        if (selectedFolder == null) {
            e.parentFolder = "Please choose a parent folder.";
        }

        setErrors(e);
        return Object.keys(e).length == 0;
    };

    const isNumeric = n => !isNaN(parseFloat(n)) && isFinite(n);

    const formatRadius = e => {
        let myVal = e.target.value;

        if (myVal == "") {
            setRadius(0);
            return;
        }

        const isDecimal = typeof myVal == "string" && myVal.match(/^(\d+\.?\d{0,9}?|\.\d{1,9}?)$/);
        if (isDecimal || typeof myVal == "number") {
            setRadius(myVal);
        }
    };

    const formatFileName = e => {
        let pass = false;
        let startChar = false;

        pass = validSnowflakeTableSpaces(e.target.value);
        startChar = validStartChar(e.target.value);

        if (startChar) {
            let me = errors;
            me.zipFileName = "The Filter Name must begin with an alpha character.";
            setErrors(me);
        } else {
            let me = errors;
            me.zipFileName = "";
            setErrors(me);
        }

        if (pass) {
            setZipFileName(e.target.value);
        }
    };

    const setFolder = (_, e) => {
        setSelectedFolder(e);
    };

    const renderExistingFolders = () => {
        const unsortedFolderList = Object.keys(folders).map(item => ({
            label: folders[item].name,
            value: folders[item].id,
            item: folders[item],
        }));

        const folderList = sortSelectOptions(unsortedFolderList);
        return (
            <FormControl>
                <Autocomplete
                    id="parent-folder"
                    options={folderList}
                    getOptionLabel={option => (option && option.label) || ""}
                    getOptionSelected={(option, value) => value.value === option.value}
                    onChange={setFolder}
                    value={selectedFolder || null}
                    error={errors.parentFolder}
                    autoComplete
                    renderInput={params => <TextField {...params} label="Parent Folder" fullWidth />}
                />
                {errors.parentFolder && <FormHelperText style={{ color: "red" }}>{errors.parentFolder}</FormHelperText>}
            </FormControl>
        );
    };

    const folderNameChange = e => {
        let folderName = e.target.value;
        folderName = folderName.replace(" ", "_");
        const pass = folderName.match(/^[a-zA-Z0-9_]+$/g);
        if (pass || folderName == "") {
            setNewFolderName(folderName);
        }
    };

    const renderFolderSelection = () => (
        <TextField
            id="create-new-folder"
            label="New Folder"
            value={newFolderName}
            onChange={folderNameChange}
            helperText="Create a folder within the selected parent folder."
        />
    );

    const handleSubmitSuccess = () => {
        setSelectedFolder(null);
        setFileName("");
        setNewFolderName("");
        setIsDisabled(true);
    };

    const handleSubmitError = () => {
        setSelectedFolder(null);
        setFileName("");
        setNewFolderName("");
        setMarkers(() => [{ id: 0, position: { lat: 0, lng: 0 } }]);
        $(successContainer.current).hide();
        setIsDisabled(true);
    };

    return (
        <MaterialModal
            id="radius-modal"
            isOpen={isOpen}
            title="Create a Multiple Radius Filter"
            primaryButtonText="Save"
            onAfterOpen={resetState}
            onClose={hide}
            cancelButtonText="Exit"
            onPrimaryButtonRequest={importFile}
            maxWidth="lg"
            fullWidth
            isPrimaryButtonDisabled={isDisabled}
        >
            <div>
                <div className="row">
                    <div className="col-sm-6">
                        <TextField
                            className="pull-left form-radius-name"
                            label={"Filter Name"}
                            helperText={errors.zipFileName}
                            error={Boolean(errors.zipFileName)}
                            onChange={e => formatFileName(e)}
                            value={zipFileName}
                            type="text"
                        />
                    </div>
                    <div className="col-sm-2">
                        <TextField
                            className="pull-left form-radius-miles"
                            inputProps={{ min: 0 }}
                            label={"Radius (miles)"}
                            helperText={errors.Radius}
                            error={Boolean(errors.Radius)}
                            onChange={e => formatRadius(e)}
                            value={radius}
                            type="number"
                        />
                    </div>
                    {hasRetentionFeature && (
                        <div className="col-sm-4">
                            <TextField
                                id="retentionDays"
                                label="Retention period (Days)"
                                helperText={"* A value of 0 means that the table should never expire."}
                                type="number"
                                inputProps={{ min: 0 }}
                                value={retentionDays}
                                onChange={e => setRetentionDays(parseInt(e.target.value))}
                            />
                        </div>
                    )}
                </div>
                <div className="row">
                    <div className="col-sm-4">{renderExistingFolders()}</div>
                    <div className="col-sm-4">{renderFolderSelection()}</div>
                    <div className="col-sm-4">
                        <FormControlLabel
                            style={{ marginTop: "15px" }}
                            control={
                                <Checkbox
                                    id="checkbox_state_line"
                                    checked={dontCrossState}
                                    onChange={() => setDontCrossState(!dontCrossState)}
                                    name={"checkboxState"}
                                    color="primary"
                                />
                            }
                            label={"Don't cross state-line"}
                        />
                    </div>
                </div>

                <div style={{ marginTop: "10px", height: "350px" }} id="mapContainer">
                    {isOpen && (
                        <MultipleAudienceRadiusMap
                            center={latlng}
                            marker={markers}
                            circle={circleLatLng}
                            radius={radius * 1609.34} /* multiply to get meters */
                            location={foundLocation}
                            showMarker={true}
                        />
                    )}
                </div>
                <Paper>
                    <div>
                        <div>
                            <IconButton onClick={DownloadSampleFile} color="primary">
                                <span>Download Example File</span>
                            </IconButton>
                        </div>
                        <div>
                            <input type="file" onChange={saveFileSelected} />
                        </div>
                        <Divider />
                        {!fileSelected && (
                            <div className="alert alert-warning-original flow-item-warnings" style={{ marginTop: 5 }}>
                                <div key="no-file-selected">
                                    <Icon style={{ marginRight: "10px", position: "relative", top: "2px" }}>
                                        error_outline
                                    </Icon>
                                    Select a file to import
                                </div>
                            </div>
                        )}
                        {fileName && !selectedFolder && !newFolderName && (
                            <div className="alert alert-warning-original flow-item-warnings" style={{ marginTop: 5 }}>
                                {!newFolderName && (
                                    <div key="no-folder-selected">
                                        <Icon style={{ marginRight: "10px", position: "relative", top: "2px" }}>
                                            error_outline
                                        </Icon>
                                        Select a Parent Folder or Type in a New Folder Name.
                                    </div>
                                )}
                            </div>
                        )}
                        {errors.Country && (
                            <div className="alert alert-warning-original flow-item-warnings" style={{ marginTop: 5 }}>
                                {!newFolderName && (
                                    <div key="no-folder-selected">
                                        <Icon style={{ marginRight: "10px", position: "relative", top: "2px" }}>
                                            error_outline
                                        </Icon>
                                        Location in file is outside the US
                                    </div>
                                )}
                            </div>
                        )}
                        {errors.BadZip && (
                            <div className="alert alert-warning-original flow-item-warnings" style={{ marginTop: 5 }}>
                                {!newFolderName && (
                                    <div key="no-folder-selected">
                                        <Icon style={{ marginRight: "10px", position: "relative", top: "2px" }}>
                                            error_outline
                                        </Icon>
                                        {errors.BadZip}
                                    </div>
                                )}
                            </div>
                        )}
                        <Divider style={{ margin: "0px auto" }} />
                    </div>
                </Paper>
                {errors.Marker && <span className="help-block">{errors.Marker}</span>}
                <div className="alert alert-info m-b-0 m-t" ref={infoContainer} style={{ display: "none" }}>
                    <div>Creating radius file.</div>
                </div>
                <div className="alert alert-success m-b-0 m-t" ref={successContainer} style={{ display: "none" }}>
                    <div ref={successMessage} className="radius-success-message">
                        Your radius (zip) file has been successfully created.
                    </div>
                </div>
                <div className="alert alert-success m-b-0 m-t" ref={parsingContainer} style={{ display: "none" }}>
                    <div ref={parsingMessage} className="radius-success-message">
                        Your location file is being parsed.
                    </div>
                </div>
            </div>
        </MaterialModal>
    );
};

AudienceMultipleRadiusModal.propTypes = {
    modalProps: PropTypes.object,
    isOpen: PropTypes.bool,
    selectedMode: PropTypes.object,
    header: PropTypes.string,
    getImports: PropTypes.func,
    getAvailableFolders: PropTypes.func,
    getColumnsForTable: PropTypes.func,
    getJoins: PropTypes.func,
};

const AudienceMultipleRadiusModalConnected = withModal(AudienceMultipleRadiusModal, "AUDIENCE_MULTIPLE_RADIUS");

export default AudienceMultipleRadiusModalConnected;
